import { render } from "./ReasonsPortal.vue?vue&type=template&id=5b523318&scoped=true"
import script from "./ReasonsPortal.vue?vue&type=script&lang=js"
export * from "./ReasonsPortal.vue?vue&type=script&lang=js"

import "./ReasonsPortal.vue?vue&type=style&index=0&id=5b523318&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b523318"]])

export default __exports__